import React from 'react';
import styles from './badge.module.scss';
import classNames from 'classnames';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const Badge = ({ children, className }: Props) => {
  const classes = classNames(styles.badgeContainer, className);
  return <div className={classes}>{children}</div>;
};
